"use strict";

var _typeof2 = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var _typeof = typeof Symbol === "function" && _typeof2(Symbol.iterator) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof2(obj);
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof2(obj);
};

var lastScrollTop = 0;
window.onload = function () {
  'use strict';

  var _createClass = function () {
    function defineProperties(target, props) {
      for (var i = 0; i < props.length; i++) {
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
      }
    }

    return function (Constructor, protoProps, staticProps) {
      if (protoProps) defineProperties(Constructor.prototype, protoProps);
      if (staticProps) defineProperties(Constructor, staticProps);
      return Constructor;
    };
  }();

  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }

  var DOMAnimations = function () {
    function DOMAnimations() {
      _classCallCheck(this, DOMAnimations);
    }

    _createClass(DOMAnimations, null, [{
      key: 'slideUp',
      value: function slideUp(element) {
        var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

        return new Promise(function (resolve, reject) {
          element.style.height = element.offsetHeight + 'px';
          element.style.transitionProperty = 'height, margin, padding';
          element.style.transitionDuration = duration + 'ms';
          element.offsetHeight; // eslint-disable-line no-unused-expressions
          element.style.overflow = 'hidden';
          element.style.height = 0;
          element.style.paddingTop = 0;
          element.style.paddingBottom = 0;
          element.style.marginTop = 0;
          element.style.marginBottom = 0;
          window.setTimeout(function () {
            element.style.display = 'none';
            element.style.removeProperty('height');
            element.style.removeProperty('padding-top');
            element.style.removeProperty('padding-bottom');
            element.style.removeProperty('margin-top');
            element.style.removeProperty('margin-bottom');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
            resolve(false);
          }, duration);
        });
      }
    }, {
      key: 'slideDown',
      value: function slideDown(element) {
        var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

        return new Promise(function (resolve, reject) {
          element.style.removeProperty('display');
          var display = window.getComputedStyle(element).display;
          if (display === 'none') display = 'block';
          element.style.display = display;
          var height = element.offsetHeight;
          element.style.overflow = 'hidden';
          element.style.height = 0;
          element.style.paddingTop = 0;
          element.style.paddingBottom = 0;
          element.style.marginTop = 0;
          element.style.marginBottom = 0;
          element.offsetHeight; // eslint-disable-line no-unused-expressions
          element.style.transitionProperty = 'height, margin, padding';
          element.style.transitionDuration = duration + 'ms';
          element.style.height = height + 'px';
          element.style.removeProperty('padding-top');
          element.style.removeProperty('padding-bottom');
          element.style.removeProperty('margin-top');
          element.style.removeProperty('margin-bottom');
          window.setTimeout(function () {
            element.style.removeProperty('height');
            element.style.removeProperty('overflow');
            element.style.removeProperty('transition-duration');
            element.style.removeProperty('transition-property');
          }, duration);
        });
      }
    }, {
      key: 'slideToggle',
      value: function slideToggle(element) {
        var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;

        if (window.getComputedStyle(element).display === 'none') {
          return this.slideDown(element, duration);
        } else {
          return this.slideUp(element, duration);
        }
      }
    }]);

    return DOMAnimations;
  }();

  //FUNCTION TO-ARRAY
  function toArray(obj) {
    var array = [];
    for (var i = obj.length >>> 0; i--;) {
      array[i] = obj[i];
    }
    return array;
  }

  //BTN PLAYER

  /*var video = toArray(document.querySelectorAll('.video-player'));
  var videoContainer = toArray(document.querySelectorAll('.container-video-player'));
  if ((typeof videoContainer === "undefined" ? "undefined" : _typeof(videoContainer)) == !'undefined' || videoContainer == null) {} else {
      videoContainer.map(function (e) {
          e.addEventListener('click', function (e) {
              e.preventDefault();
              if (this.classList.contains("active")) {
                  this.classList.remove("active");
                  DOMAnimations.slideDown(this.firstElementChild);
                  this.lastElementChild.pause();
              } else {
                  this.classList.add("active");
                  DOMAnimations.slideUp(this.firstElementChild);
                  this.lastElementChild.play();
              }
          });
      });
  }*/

  //BTN MODAL
  // var btnModalOpenVideo = document.querySelector('.btn-immerse-yourself');
  // //var btnModalClose = document.querySelector('.btn-close');
  // var videoModal = document.getElementById('video-modal');
  // if ((typeof btnModalOpenVideo === "undefined" ? "undefined" : _typeof(btnModalOpenVideo)) == !'undefined' || btnModalOpenVideo == null) {
  // } else {
  //
  //   btnModalOpenVideo.addEventListener('click', function (e) {
  //     if (window.matchMedia("(min-width: 768px)").matches) {
  //       e.preventDefault();
  //       videoModal.classList.add("open");
  //     }
  //   });
  // }
  /*if ((typeof btnModalClose === "undefined" ? "undefined" : _typeof(btnModalClose)) == !'undefined' || btnModalClose == null) {} else {

      btnModalClose.addEventListener('click', function (e) {
          e.preventDefault();
          videoModal.classList.remove("open");
          video.map(function (e) {
              DOMAnimations.slideDown(e.previousElementSibling);
              e.pause();
          });
          videoContainer.map(function (e) {
              e.classList.remove("active");
          });
      });
  }*/

  //BTN MODAL
  var btnModalOpen = jQuery('.btn-modal');
  var btnModalClose = jQuery('.js-btn-close');

  if (btnModalOpen.length) {
    btnModalOpen.on('click', function (e) {
      e.preventDefault();

      var btnModalAttr = jQuery(this).attr("data-modal");
      var modal = jQuery("#" + btnModalAttr);
      jQuery("#" + btnModalAttr + ' .btn-blue').attr("href", jQuery(this).attr("href"));

      modal.addClass("open");

      if (modal.hasClass('open')) {

        //attrape tout les elements focusable des modals
        let focusableElements = modal.find('button, a, input:not([type="hidden"]), select, textarea, [tabindex]:not([tabindex="-1"])');

        //focus le premier element
        focusableElements.first().focus();

        document.onkeydown = function (evt) {
          if (modal.hasClass('open')) {
            let keyCode = evt.keyCode || evt.which;

            //focus first element une fois que l'on était sur le dernier
            if (keyCode === 9) {
              if (focusableElements.last().is(":focus")) {
                focusableElements.first().focus();
              }
            }

            //press ESC to close modal
            if (keyCode === 27) {
              btnModalClose.click();
            }

            if (keyCode === 13) {
              if (jQuery('.js-btn-close').is(":focus")) {
                btnModalClose.click();
              }
            }
          }
        };
      }

    });
  }

  if (btnModalClose.length) {

    btnModalClose.on('click', function (e) {
      e.preventDefault();

      var btnModalAttr = jQuery(this).closest('div.open');
      var modal = jQuery("#" + btnModalAttr[0].id);

      modal[0].classList.remove("open");

      /* fonction pour stopper la video lorsque l'on clique sur le bouton de fermeture de la modale */
      var stopVideo = function (element) {
        var iframe = element.querySelector('iframe');
        var video = element.querySelector('video');
        if (iframe) {
          var iframeSrc = iframe.src;
          iframe.src = iframeSrc;
        }
        if (video) {
          video.pause();
        }
      };

      stopVideo(document.querySelector("#video-modal"));

    });
  }

  /*btnModalOpen.map(function (e) {
      e.addEventListener('click', function (e) {
          e.preventDefault();

          var btnModalAttr = this.attributes["data-modal"].value;

          console.log(btnModalAttr);

      });
  });*/


  var btnClickPodcast = jQuery('#click-podcast');
  if (btnClickPodcast.length) {
    btnClickPodcast.on('click', function (e) {
      e.preventDefault();
      window.location.href = jQuery(this).attr('data-href');
    });
  };

  //FUNCTION SCROLL TO TOP
  var btnBackToTop = jQuery('.btn-back-to-top');
  if (btnBackToTop.length) {
    btnModalClose.on('click', function (e) {
      e.preventDefault();
      scrollTo(document.documentElement, 0, 300);
    });
  };

  function scrollTo(element, to, duration) {
    var start = element.scrollTop,
      change = to - start,
      currentTime = 0,
      increment = 20;

    var animateScroll = function animateScroll() {
      currentTime += increment;
      var val = Math.easeInOutQuad(currentTime, start, change, duration);
      element.scrollTop = val;
      if (currentTime < duration) {
        setTimeout(animateScroll, increment);
      }
    };
    animateScroll();
  };
  Math.easeInOutQuad = function (t, b, c, d) {
    t /= d / 2;
    if (t < 1) return c / 2 * t * t + b;
    t--;
    return -c / 2 * (t * (t - 2) - 1) + b;
  };

  //FUNCTION FILTERS SOCIAL WALL
  var itemFilter = toArray(document.querySelectorAll(".social-filters li a"));

  itemFilter.map(function (e) {
    e.addEventListener('click', function (e) {
      e.preventDefault();
      itemFilter.map(function (e) {
        e.classList.remove("active");
        e.removeAttribute("aria-current", "true");
      });
      this.classList.add("active");
      this.setAttribute("aria-current", "true");
    });
  });

  //FUNCTION OPEN MENU HOVER
  var timer;
  var menu = jQuery(".menu-elem");
  var menulinkmobile = jQuery(".nav-mobile .menu-elem > div > div");

  menu.on("click", "> div > div > a", function (e) {
    e.preventDefault();
  });

  menulinkmobile.each(function (){
    jQuery(this).children("a").attr('aria-controls', jQuery(this).children("a").text());
    jQuery(this).children("a").attr('aria-expanded', 'false');
    jQuery(this).children("ul").attr('id', jQuery(this).children("a").text());
    jQuery(this).children("ul").attr('aria-labelledby', jQuery(this).children("a").text());
  });



  menu.on("mouseenter", "> div > div", function () {
    var that = this;
    timer = setTimeout(function () {
      jQuery(that).children("ul").slideDown();
      jQuery(that).children("a").attr('aria-expanded', 'true');
    }, 200);
  }).on("mouseleave", "> div > div", function () {
    var that = this;
    clearTimeout(timer);
    jQuery(that).children("ul").slideUp();
    jQuery(that).children("a").attr('aria-expanded', 'false');
  });

  //FUNCTION OPEN BURGER
  var burger = document.querySelector(".burger");

  if ((typeof burger === "undefined" ? "undefined" : _typeof(burger)) == !'undefined' || burger == null) {
  } else {
    burger.addEventListener("click", function (e) {
      e.preventDefault();
      if (this.classList.contains("active")) {
        this.classList.remove("active");
        DOMAnimations.slideUp(document.querySelector(".nav-mobile>.menu-elem>div"));
        DOMAnimations.slideUp(document.querySelector(".nav-mobile>.menu-elem .social"));
      } else {
        this.classList.add("active");
        DOMAnimations.slideDown(document.querySelector(".nav-mobile>.menu-elem>div"));
        DOMAnimations.slideDown(document.querySelector(".nav-mobile>.menu-elem .social"));
      }
    });
  }

  // FUNCTION SCROLL MOBILE
  var winScrollY = function winScrollY() {
    return window.scrollY;
  };
  var nav = document.querySelector(".main-nav");

  if (window.matchMedia("(min-width: 768px)").matches) {
  } else {
    window.addEventListener('scroll', function () {
      winScrollY();

      if (winScrollY() >= 90) {
        nav.classList.add("scrolled");
      } else {
        nav.classList.remove("scrolled");
      }
    });
  }

  // FUNCTION SWITCH MOBILE REMOTE
  jQuery(".js-mobile-switch a").on('click', function (e) {
    e.preventDefault();
    jQuery(this).toggleClass('skin-btn');
    jQuery(this).parent().prev(".jobs").slideToggle();
    if (jQuery(this).hasClass('skin-btn')) {
      jQuery(this).find('.sr-only').html('Masquer les services');
    } else {
      jQuery(this).find('.sr-only').html('Afficher les services');
    }
  });


  //FUNCTION BTN SWITCH LIST TO MAP
  /*var btnSwitch = toArray(document.querySelectorAll(".ct-header-list .btn-container a"));

  btnSwitch.map(function (e) {
      e.addEventListener('click', function (e) {
          e.preventDefault();
          if (this.attributes["data-attr"].value === "map") {
              jQuery(".list-elems").slideUp();
              jQuery(".container-map").slideDown();
              map.invalidateSize()
          } else {
              jQuery(".list-elems").slideDown();
              jQuery(".container-map").slideUp();
              map.invalidateSize()
          }

          btnSwitch.map(function (i) {
              i.classList.remove("active");
          });

          this.classList.add("active");
      });
  });*/

  //BTN BROWSE FILES
  var btnBrowse = toArray(document.querySelectorAll(".container-form .btn-browse"));

  btnBrowse.map(function (e) {
    e.addEventListener('click', function (e) {
      e.preventDefault();
      insert_file(this.previousElementSibling);
    });
  });

  function insert_file(elem) {
    var input_neighbor = elem;
    input_neighbor.click();
    input_neighbor.addEventListener('change', function (e) {
      var inputValue = input_neighbor.value.split("\\");
      var spanText = input_neighbor.nextElementSibling.nextElementSibling;
      spanText.innerHTML = "";
      var spanTextTemplate = "Document s\xE9lectionn\xE9 : <span class=\"bold\">" + inputValue[inputValue.length - 1] + "</span> <span>(548ko)</span>";
      spanText.innerHTML = spanTextTemplate;
    });
  }

  // GAB 4 CARTRIDGES
  var cartridge = toArray(document.querySelectorAll(".headband-signboards .elem"));

  cartridge.map(function (e) {
    e.addEventListener('mouseenter', function (e) {
      e.preventDefault();
      jQuery(this).find(".ct-txt").stop().slideDown();
      this.classList.add("active");
    });
    e.addEventListener('mouseleave', function (e) {
      e.preventDefault();
      jQuery(this).find(".ct-txt").stop().slideUp();
      this.classList.remove("active");
    });
    e.addEventListener('click', function (e) {
      e.stopPropagation();
    });
  });

  //SHOW NUMBER OFFERS

  var containerNumberVal = jQuery(".container-offers-number-ascent .js-hidden");
  var containerNumber = jQuery(".container-offers .number-in-live");
  var paragraphCount = jQuery(".paragraph-offer-count .number-in-live");
  var containerNumberSplit = containerNumberVal.html().split("");
  jQuery(".container-offers .number-in-live").empty();
  for (var i = 0; i < containerNumberSplit.length; i++) {
    var spanElem = "<span>" + containerNumberSplit[i] + "</span>";
    jQuery(spanElem).appendTo(containerNumber);
    jQuery(spanElem).appendTo(paragraphCount);
  }

  //Pages enseignes - Redirections vers la page générale
  jQuery('.redirect').click(function (e) {
    e.preventDefault();
    var r = confirm('Attention, tu vas être redirigé vers le site Groupe SAMSE recrute');
    if (r == true) {
      window.location.replace(jQuery(this).attr("href"));
    } else {
      exit();
    }
    ;
  });

  jQuery("#selectCategorySpontanee").change(function (e) {
    var ref = this.value;

    jQuery.ajax({
      type: "POST",
      url: '/ajax/getform',
      data: {
        'ref': ref
      },
      async: true
    }).done(function (data) {
      jQuery('#form-content').html(data.form);
      jQuery('#showRef').html(ref);
      jQuery('#ref').html(ref);
    });
  });

  jQuery("#see-job-video").click(function (e) {
    e.preventDefault();
    jQuery(".ribbon").hide();
    jQuery("#see-job-video").hide();
    jQuery(".container-video-offer iframe")[0].src += "?controls=0&autoplay=1&cc_lang_pref=fr&cc_load_policy=1";
    e.preventDefault();
  });


  jQuery('.menu-principal').on('click touch mouseover', function (evt) {
    if (evt.target.innerHTML === 'Je recherche') {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'clic-je-cherche', {'event_category': 'Header', 'event_label': 'Je cherche'});
      }
    }
    if (evt.target.innerHTML === 'Le Groupe et moi') {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'clic-le-groupe-et-moi', {'event_category': 'Header', 'event_label': 'Le groupe et moi'});
      }
    }
  });

  jQuery('#offer-search-submit').on('click touch', function (evt) {
    if (jQuery('#field_categorie option:selected').html() !== 'Métier') {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'recherche', {
          'event_category': 'Recherche',
          'event_label': jQuery('#field_categorie option:selected').html()
        });
      }
    }

    if (jQuery('#field_enseigne option:selected').html() !== 'Enseigne') {
      if (typeof gtag !== 'undefined') {
        gtag('event', 'recherche', {
          'event_category': 'Recherche',
          'event_label': jQuery('#field_enseigne option:selected').html()
        });
      }
    }
  });

  /* POPIN CORONAVIRUS
  var isshow = localStorage.getItem('status');
  console.log(isshow);
  if (isshow == null) {
      localStorage.setItem('isshow', 1);

      // Show popup here
      jQuery("#coronavirus").show();

      jQuery("#coronavirus-close").on('click', function (e) {
          jQuery(this).closest("#coronavirus").hide();
          e.preventDefault;
      });

  }; */
  /*
      let elementsArray = document.querySelectorAll("#coronavirus-close, #coronavirus-btn");
      elementsArray.forEach(function(elem) {
          elem.addEventListener("click", function(event) {
              document.getElementById('coronavirus').style.display = "none";
              event.preventDefault();
          });
      });
  */

};

/* Animation de la page Notre Process de Recrutement et Perfect Match */
jQuery(document).ready(function () {
  //jQuery('html,body').animate({scrollTop: 0}, 'fast');

  jQuery('.anchor').click(function (e) {
    var url = jQuery(this).attr('href');
    if (url.indexOf('#') !== -1) {
      e.preventDefault();
      var id = url.split('#')[1];
      var offset = jQuery('#' + id).offset().top - 80;
      jQuery('html, body').animate({scrollTop: offset}, 800);
    }
  });

  if (jQuery('#recrutpage').length !== 0) {
    var s = skrollr.init({
      'smoothScrollingDuration': 5
    });

    ScrollReveal({mobile: false});

    ScrollReveal().reveal('.recrutprocess', {
      delay: 0,
      duration: 500,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '10px',
      origin: 'bottom',
      useDelay: 'always'
    });

    ScrollReveal().reveal('.recrutprocess-intro img', {
      delay: 100,
      duration: 600,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '30px',
      origin: 'right',
      useDelay: 'always'
    });
    ScrollReveal().reveal('.recrutprocess-intro .text', {
      delay: 400,
      duration: 600,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '30px',
      origin: 'right',
      useDelay: 'always'
    });

    ScrollReveal().reveal('.recrutprocess-step:not(.stepright) .step', {
      delay: 300,
      duration: 600,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '50px',
      origin: 'left',
      useDelay: 'always'
    });
    ScrollReveal().reveal('.recrutprocess-step:not(.stepright) .image', {
      delay: 1000,
      duration: 800,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '60px',
      origin: 'bottom',
      useDelay: 'always'
    });
    ScrollReveal().reveal('.recrutprocess-step:not(.stepright) .extrastep', {
      delay: 800,
      duration: 800,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '60px',
      origin: 'left',
      useDelay: 'always'
    });
    ScrollReveal().reveal('.recrutprocess-step:not(.stepright) .text', {
      delay: 800,
      duration: 700,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '100px',
      origin: 'right',
      useDelay: 'always'
    });

    ScrollReveal().reveal('.recrutprocess-step.stepright .step', {
      delay: 300,
      duration: 600,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '50px',
      origin: 'right',
      useDelay: 'always'
    });
    ScrollReveal().reveal('.recrutprocess-step.stepright .image', {
      delay: 1000,
      duration: 800,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '60px',
      origin: 'top',
      useDelay: 'always'
    });
    ScrollReveal().reveal('.recrutprocess-step.stepright .extrastep', {
      delay: 800,
      duration: 800,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '60px',
      origin: 'right',
      useDelay: 'always'
    });
    ScrollReveal().reveal('.recrutprocess-step.stepright .text', {
      delay: 800,
      duration: 700,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '100px',
      origin: 'left',
      useDelay: 'always'
    });

    ScrollReveal().reveal('.laststep .cta', {
      delay: 1200,
      duration: 1000,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '100px',
      origin: 'left',
      useDelay: 'always'
    });

    ScrollReveal().reveal('.container-join-us', {
      delay: 200,
      duration: 800,
      easing: 'ease-in-out',
      opacity: 0,
      distance: '200px',
      origin: 'bottom',
      useDelay: 'always'
    });
  }

  // PERFECT MATCH
  if (jQuery("#perfect-match-form-result").length) {
    jQuery('html, body').animate({
      scrollTop: jQuery("#perfect-match-form-result").offset().top - 100
    }, 2000);
  }

  jQuery('.container-is-enseigne .form-checkboxes input[id^="edit-tag-"]').click(function () {
    //console.log('Remove Query');
    if (window.location.href.split('?')[1]) {
      window.history.pushState("", "", window.location.href.split('?')[0]);
      location.reload()
    }
  });

  // Afficher / cacher le mdp compte candidat
  jQuery('.logincandidate-login .password-eye').click(function() {
    if(jQuery('.logincandidate-login .password-eye').hasClass('show')) {
      jQuery('.logincandidate-login .password-eye').removeClass('show');
      jQuery('.logincandidate-login #edit-password').attr('type', 'password');
      jQuery('.logincandidate-login .password-eye .icon').removeClass('eye-show');
    }else {
      jQuery('.logincandidate-login .password-eye').addClass('show');
      jQuery('.logincandidate-login #edit-password').attr('type', 'text');
      jQuery('.logincandidate-login .password-eye .icon').addClass('eye-show');
    }
  });
});

/* Active a11y */
jQuery(document).ready(function () {
  window.addEventListener('keydown', (e) => {

    if (e.key == 'Tab') {
      window.document.querySelector("body").classList.remove('no-focus-outline');
    }
    if (e.key == 'Enter') {
      if (e.target.classList[0] == 'level0--link') {
         if(jQuery('.menu-elem>div>div>a.' + e.target.classList[1] + '+ul').hasClass('active')) {
           jQuery('.menu-elem>div>div>a+ul').hide();
           jQuery('.menu-elem>div>div>a.' + e.target.classList[1] + '+ul').removeClass('active');
           jQuery('.menu-elem>div>div>a').attr('aria-expanded', 'false');
         }else{
           jQuery('.menu-elem>div>div>a+ul').hide();
           jQuery('.menu-elem>div>div>a').attr('aria-expanded', 'false');
           jQuery('.menu-elem>div>div>a.' + e.target.classList[1]).attr('aria-expanded', 'true');
           jQuery('.menu-elem>div>div>a.' + e.target.classList[1] + '+ul').addClass('active').toggle();
         }
      }
    }
  });

});

jQuery(document).ready(function () {
  jQuery('.youtube-thumbnail').click(function () {
    loadVideo(this);
  });
  function loadVideo(link) {
    if (window.matchMedia("(min-width: 768px)").matches) {
      iframeSrc = jQuery('img', link).attr('data-iframe-src');

      iframeSrc = iframeSrc+'?rel=0&autoplay=1';
      imgSrc = jQuery('img', link).attr('src').split('/');
      videoId = imgSrc[4];
      jQuery(link).replaceWith('<div class="container-video-youtube"><lite-youtube class="img" data-requires-vendor-consent="Youtube" videoid="'+videoId+'" params="rel=0&cc_lang_pref=fr&cc_load_policy=1"></lite-youtube></div>');
      jQuery('iframe[data-id="'+videoId+'"]').attr('src', iframeSrc);
    }
  }
});

/*
if (readCookie('popin-coronavirus') === 'true') {
 document.getElementById('coronavirus').style.display = "none";
} else {

 document.getElementById('coronavirus').style.display = "flex";
}

createCookie('popin-coronavirus', 'true');

function createCookie(name, value, days) {
 var expires = "";
 if (days) {
     var date = new Date();
     date.setTime(date.getTime() + (days * 3600 * 1000 * 24 * 365 * 10));
     expires = "; expires=" + date.toUTCString();
 }
 document.cookie = name + "=" + value + expires + "; path=/";
}

function readCookie(name) {
 var nameEQ = name + "=";
 var ca = document.cookie.split(';');
 for (var i = 0; i < ca.length; i++) {
     var c = ca[i];
     while (c.charAt(0) == ' ') c = c.substring(1, c.length);
     if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
 }
 return null;
}*/


/*
 *   This content is licensed according to the W3C Software License at
 *   https://www.w3.org/Consortium/Legal/2015/copyright-software-and-document
 *
 *   File:   disclosure-button.js
 *
 *   Desc:   Disclosure button widget that implements ARIA Authoring Best Practices FAQ
 */

'use strict';

/*
 *   @constructorDisclosureButton
 *
 *
 */
class DisclosureButton {
  constructor(buttonNode) {
    this.buttonNode = buttonNode;
    this.controlledNode = false;

    var id = this.buttonNode.getAttribute('aria-controls');

    if (id) {
      this.controlledNode = document.getElementById(id);
    }

    this.buttonNode.setAttribute('aria-expanded', 'false');
    this.hideContent();

    this.buttonNode.addEventListener('click', this.onClick.bind(this));
    this.buttonNode.addEventListener('focus', this.onFocus.bind(this));
    this.buttonNode.addEventListener('blur', this.onBlur.bind(this));
  }

  showContent() {
    if (this.controlledNode) {
      this.controlledNode.style.display = 'block';
    }
  }

  hideContent() {
    if (this.controlledNode) {
      this.controlledNode.style.display = 'none';
    }
  }

  toggleExpand() {
    if (this.buttonNode.getAttribute('aria-expanded') === 'true') {
      this.buttonNode.setAttribute('aria-expanded', 'false');
      this.hideContent();
    } else {
      this.buttonNode.setAttribute('aria-expanded', 'true');
      this.showContent();
    }
  }

  /* EVENT HANDLERS */

  onClick() {
    this.toggleExpand();
  }

  onFocus() {
    this.buttonNode.classList.add('focus');
  }

  onBlur() {
    this.buttonNode.classList.remove('focus');
  }
}

/* Initialize Hide/Show Buttons */

window.addEventListener(
  'load',
  function () {
    var buttons = document.querySelectorAll(
      'div[aria-expanded][aria-controls]'
    );

    for (var i = 0; i < buttons.length; i++) {
      new DisclosureButton(buttons[i]);
    }
  },
  false
);


var btnImmerse = jQuery('.btn-immerse-yourself');
var btnSpan = btnImmerse.find('> span');
var videoFrame = jQuery('#video-samse-rh');

btnImmerse.click(async function () {
  var isPaused = btnImmerse.hasClass('paused');
  var video = await document.getElementById('video-samse-rh').getYTPlayer();
  btnImmerse.toggleClass('paused');
  btnSpan.toggleClass('icon-pause-button icon-play-button-full');
  jQuery('.sub-title-video').text(isPaused ? 'Voir la Vidéo' : 'Cacher la vidéo');
  isPaused ? video.pauseVideo() : video.playVideo();
  videoFrame.css('zIndex', isPaused ? '-1' : '1');
});

jQuery("#transcription").on('click',function(){
  var Check = jQuery("#transcription").attr("aria-expanded");

  if ( Check == "true") {
    jQuery("#transcription").attr("aria-expanded", "false");
    jQuery(".ct-video__transcription").attr("aria-hidden", "true");
  } else {
    jQuery("#transcription").attr("aria-expanded", "true");
    jQuery(".ct-video__transcription").attr("aria-hidden", "false");
  }
});
